import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=46a4ec22"
import script from "./Notices.vue?vue&type=script&lang=js"
export * from "./Notices.vue?vue&type=script&lang=js"
import style0 from "./Notices.vue?vue&type=style&index=0&id=46a4ec22&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports